<template>
  <b-row>
    <b-col md="12">
      <b-row
        class="text-right mx-md-3 mx-lg-3"
      >
        <b-col md="8">
          <b-overlay
            :show="loader.formulario"
            opacity="0.50"
            rounded="sm"
          >
            <!-- IF WE DON'T HAVE ERROR -->
            <b-card>
              <h2
                class="text-center"
                style="color:#aa9d6b;"
              >Por correo electrónico</h2>
              <hr class="m-2">
              <!-- TÍTULO DE CARD, NOMBRE DE EVENTO Y ICON -->
              <titleSection
                title="Formulario de contacto"
                icon="MailIcon"
                class="m-2"
              />
              <validation-observer ref="simpleRules">
                <b-form>
                  <b-row>
                    <b-col>
                      <b-form-group
                        label="Tema"
                        label-for="tema"
                        label-cols-md="2"
                      >
                        <b-form-select
                          v-model="formulario.tema"
                          :options="this.$store.getters['contacto/get_temas']"
                          value-field="id_tema"
                          text-field="tema"
                          :state="formulario.tema === null ? false : true"
                          required
                          @change="getOptionsReset"
                        >
                          <template #first>
                            <b-form-select-option
                              :value="null"
                              disabled
                            >
                              -- Selecciona --
                            </b-form-select-option>
                          </template>

                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group
                        label="Asunto"
                        label-for="subTema"
                        label-cols-md="2"
                      >
                        <b-form-select
                          v-model="formulario.sub_tema"
                          :options="this.$store.getters['contacto/get_subtemas'](formulario.tema)"
                          value-field="id_subtema"
                          text-field="subtema"
                          :state="formulario.sub_tema === null ? false : true"
                          required
                          @change="getAsunto(formulario.tema, formulario.sub_tema)"
                        >
                          <template #first>
                            <b-form-select-option
                              :value="null"
                              disabled
                            >-- Selecciona el asunto --</b-form-select-option>
                          </template>

                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group
                        label="Nombre"
                        label-for="nombre"
                        label-cols-md="2"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="nombre"
                          rules="required|min:3|alpha_spaces|max:45"
                        >
                          <b-input-group class="input-group-merge">
                            <b-input-group-prepend is-text>
                              <feather-icon icon="UserIcon" />
                            </b-input-group-prepend>
                            <b-form-input
                              id="nombre"
                              v-model="formulario.nombre"
                              placeholder="Nombre"
                              :state="errors.length > 0 ? false:null"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group
                        label="Email"
                        label-for="email"
                        label-cols-md="2"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="email"
                          rules="required|email"
                        >
                          <b-input-group
                            class="input-group-merge"
                          >
                            <b-input-group-prepend is-text>
                              <feather-icon icon="MailIcon" />
                            </b-input-group-prepend>
                            <b-form-input
                              id="mail"
                              v-model="formulario.email"
                              type="email"
                              placeholder="Email"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col>
                      <b-form-group
                        label="Celular"
                        label-for="celular"
                        label-cols-md="2"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="celular"
                          rules="required|min:10|max:10"
                        >
                          <b-input-group class="input-group-merge">
                            <b-input-group-prepend is-text>
                              <feather-icon icon="SmartphoneIcon" />
                            </b-input-group-prepend>
                            <b-form-input
                              id="celular"
                              v-model="formulario.celular"
                              type="number"
                              placeholder="Celular"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col>
                      <b-form-group
                        label="Mensaje"
                        label-for="mensaje"
                        label-cols-md="2"
                      >
                        <b-form-textarea
                          id="mensaje"
                          v-model="formulario.mensaje"
                          :state="formulario.mensaje.length >= 10"
                          placeholder="Mensaje minimo 10 caracteres"
                          rows="3"
                          max-rows="8"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col md="12">
                      <b-button
                        class="mr-2"
                        variant="primary"
                        @click.prevent="validationForm"
                      >
                        Enviar
                      </b-button>
                      <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        type="reset"
                        variant="outline-secondary"
                      >
                        Limpiar campos
                      </b-button>
                    </b-col>
                  </b-row>

                </b-form>
              </validation-observer>
            </b-card>
          </b-overlay>
        </b-col>

        <b-col md="4">
          <mapa />
        </b-col>

      </b-row>
      <directorio />
    </b-col>
  </b-row>
</template>

<script>
import { postData } from '@core/utils/http/general'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol,
  BInputGroup, BFormInput, BFormGroup, BForm, BInputGroupPrepend,
  BFormTextarea, BFormSelect, BFormSelectOption, BButton,
  BCard, BOverlay,
  VBToggle,
} from 'bootstrap-vue'
import { required } from '@validations'
import titleSection from '@/views/components/title-section.vue'
import Ripple from 'vue-ripple-directive'
import directorio from './components/directorio.vue'
import mapa from './components/mapa.vue'

let interval // INTERVALO PARA HACER REDIRECT DESPUÉS DE 45MIN SIN HACER SUBMIT

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    titleSection,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    directorio,
    mapa,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  data() {
    return {
      // FORM
      formulario: {
        tema: null,
        sub_tema: null,
        asunto: null,
        nombre: '',
        email: '',
        celular: '',
        mensaje: '',
      },
      // VALIDATIONS
      required,
      // EXTRA
      counter: 1,
      loader: {
        formulario: false,
      },
      error_page: false,
    }
  },

  created() {
    const registeredIP = new Promise((resolve, reject) => {
      this.get_requestform(resolve, reject)
    })

    registeredIP.then(() => {
      this.intervalRedirect()
      this.loadAsunto()
    })
      .catch(error => {
        this.error_page = true
        this.loader.formulario = false
        this.$bvToast.toast(error, {
          title: 'Error en solicitud',
          variant: 'danger',
          solid: true,
        })
      })
  },
  methods: {
    getOptionsReset() {
      this.formulario.sub_tema = null
      this.formulario.asunto = null
    },
    getAsunto(tema, subtema) {
      try {
        this.respuesta = this.$store.getters['contacto/get_asunto'](tema, subtema)
        this.formulario.asunto = this.respuesta[0].id_asunto
      // eslint-disable-next-line no-empty
      } catch (e) { }
    },
    loadAsunto() {
      const { x } = this.$route.query
      this.loader.formulario = true
      this.$store.dispatch('contacto/loadAsuntos')
        .then(() => {
          if (x && !Number.isNaN(x)) this.formulario.tema = parseInt(x, 10)
          this.loader.formulario = false
        }, error => {
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Error en solicitud [temas]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitForm()
        }
      })
    },
    submitForm() {
      if (this.counter <= 10) {
        const params = new FormData()
        this.loader.formulario = true
        params.append('task', 'contacto')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('action', 3)
        params.append('data', JSON.stringify(this.formulario))

        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              this.registroExitoso()
            } else {
              this.$bvToast.toast(response.data.message, {
                title: `${response.data.status} - Error al realizar post`,
                variant: 'danger',
                solid: true,
              })
              // this.tbl = response.data.tbl
            }
            this.loader.formulario = false
          })
          .catch(err => {
            // this.promise_tbl_nla() // MAKE PROMISE TO TBL REQUEST
            this.loader.formulario = false
            this.$bvToast.toast(err, {
              title: 'Error en solicitud [submit]',
              variant: 'danger',
              solid: true,
            })
          })

        this.counter += 1
      } else {
        this.$bvToast.toast('La página ha expirado, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    registroExitoso() {
      this.$swal({
        title: '<b>Correo enviado</b>',
        html: '<b>Te responderemos pronto<hr><b> Gracias :) ',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
      this.clearForm()
    },
    get_requestform(resolve, reject) {
      this.loader.formulario = true
      const params2 = new FormData()
      params2.append('task', 'contacto')
      params2.append('origin', process.env.VUE_APP_ORIGIN_API)
      params2.append('action', 4)

      postData(params2)
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.tbl = 100 // response.data.data.tbl CHECAR
            resolve()
          } else {
            reject(response.data.message)
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error al cargar el formulario intentelo más tarde`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.formulario = false
        })
        .catch(err => {
          reject(err)
          this.loader.formulario = false
          this.$bvToast.toast(err, {
            title: 'Error al cargar el formulario, No hay conexión',
            variant: 'danger',
            solid: true,
          })
        })
    },
    intervalRedirect() {
      interval = setInterval(() => {
        if (this.tbl === this.old_tbl) {
          this.$bvToast.toast('El formulario contacto ha expirado, ingrese nuevamente', {
            title: 'Formulario caducado',
            variant: 'warning',
            solid: true,
          })
          clearInterval(interval)
          this.$router.push('/')
        }
        this.old_tbl = this.tbl
      }, 2700000)
    },
    clearForm() {
      Object.keys(this.formulario).forEach(key => { this.formulario[key] = '' })
      this.formulario.tema = null
      this.formulario.sub_tema = null
      this.formulario.asunto = null
    },

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
.vue2leaflet-map{
  &.leaflet-container{
    height: 350px;
  }
}

.card {
    background-color: #f8f8f8;
}
</style>
